import axios from "axios";
import {UserResponseDto} from "../../types/DTOs/userResponseDto";


export const getSelf = () => {
  return axios.get<UserResponseDto>('/users/self')
}
